module.exports = __webpack_public_path__ + "assets/img/4914-ci.svg";